<template lang="pug">
  .component-start-end-timepicker
    select()
      option(v-for="hour in hours") {{hour}}

</template>

<script>
    import moment from 'moment'

    export default {
        name: 'StartEndTimePicker',

        computed: {
            hours() {
                const date = moment().hours(0).minutes(0).seconds(0)
                console.log(date)
                let hours = []
                hours.push(date.format('HH:mm'))

                for (let i = 0; i < 47; i++) {
                    hours.push(date.add(30, 'minutes').format('HH:mm'))
                }
                return hours
            }
        },
        props:['value']

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// StartEndTimePicker.vue?0ac5eae4